import {axiosInstance} from '../../utils';

const actions = {
    FETCH_SETTINGS_REQUESTED: 'FETCH_SETTINGS_REQUESTED',
    FETCH_SETTINGS_SUCCEEDED: 'FETCH_SETTINGS_SUCCEEDED',
    FETCH_SETTINGS_FAILED: 'FETCH_SETTINGS_FAILED',

    UPDATE_SETTINGS_REQUESTED: 'UPDATE_SETTINGS_REQUESTED',
    UPDATE_SETTINGS_SUCCEEDED: 'UPDATE_SETTINGS_SUCCEEDED',
    UPDATE_SETTINGS_FAILED: 'UPDATE_SETTINGS_FAILED',

    CLEAR_ALERT_MESSAGE: 'CLEAR_ALERT_MESSAGE',

    clearAlertMessage:() => {
        return {
            type: actions.CLEAR_ALERT_MESSAGE
        }
    },

    updateSettings: (params = undefined) => {
        return {
            type: actions.UPDATE_SETTINGS_REQUESTED,
            payload: params
        }
    },

    fetchSettings: (params = undefined) => {
        return {
            type: actions.FETCH_SETTINGS_REQUESTED,
            payload: params
        }
    },

    getSettings: async (params = undefined) => {
        const url = `settings`;

        try {
            const settings = await axiosInstance.get(url,{ params });
            return settings.data;
        } catch (error) {
            throw error;
        }
    },

    updateSettingsData: async (data = undefined) => {
        const url = `settings`;

        let bodyFormData = new FormData();
        if (data.facebook) bodyFormData.set('facebook', data.facebook);
        if (data.instagram) bodyFormData.set('instagram', data.instagram );
        if (data.twitter) bodyFormData.set('twitter', data.twitter );
        if (data.privacy) bodyFormData.set('privacy', data.privacy );
        if (data.privacy_ar) bodyFormData.set('privacy_ar', data.privacy_ar );
        if (data.logo) bodyFormData.append('logo', data.logo );
        if (data.logo_ar) bodyFormData.append('logo_ar', data.logo_ar );
        if (data.description) bodyFormData.append('description', data.description );
        if (data.description_ar) bodyFormData.append('description_ar', data.description_ar );
        if (data.delivery_policy) bodyFormData.append('delivery_policy', data.delivery_policy );
        if (data.delivery_policy_ar) bodyFormData.append('delivery_policy_ar', data.delivery_policy_ar );
        if (data.refund_policy) bodyFormData.append('refund_policy', data.refund_policy );
        if (data.refund_policy_ar) bodyFormData.append('refund_policy_ar', data.refund_policy_ar );
        if (data.support_email) bodyFormData.append('support_email', data.support_email );
        if (data.contact_phone) bodyFormData.append('contact_phone', data.contact_phone );
        if (data.short_terms) bodyFormData.append('short_terms', data.short_terms );
        if (data.short_terms_ar) bodyFormData.append('short_terms_ar', data.short_terms_ar );
        if (data.terms) bodyFormData.append('terms', data.terms );
        if (data.terms_ar) bodyFormData.append('terms_ar', data.terms_ar );
        if (data.about) bodyFormData.append('about', data.about );
        if (data.about_ar) bodyFormData.append('about_ar', data.about_ar);
        if (data.default_otp) bodyFormData.append('default_otp',
            data.default_otp);
        if (data.free_delivery_threshold !== undefined && data.free_delivery_threshold !== null) {
            bodyFormData.append('free_delivery_threshold', data.free_delivery_threshold);
        }
        if (data.free_delivery_radius_km !== undefined && data.free_delivery_radius_km !== null) {
            bodyFormData.append('free_delivery_radius_km', data.free_delivery_radius_km);
        }
        if (data.delivery_fee_per_extra_km_jod !== undefined && data.delivery_fee_per_extra_km_jod !== null) {
            bodyFormData.append('delivery_fee_per_extra_km_jod', data.delivery_fee_per_extra_km_jod);
        }
        if (data.base_delivery_fee_jod !== undefined && data.base_delivery_fee_jod !== null) {
            bodyFormData.append('base_delivery_fee_jod', data.base_delivery_fee_jod);
        }
        if (data.excluded_from_delivery_threshold_classifications !== undefined) {
            // Convert array of objects to JSON string for FormData
            // Send empty array if no classifications selected (to allow clearing)
            bodyFormData.append('excluded_from_delivery_threshold_classifications', JSON.stringify(data.excluded_from_delivery_threshold_classifications || []));
        }

        try {
            const settings = await axiosInstance.post(url, bodyFormData)
            return settings.data;
        } catch (error) {
            throw error;
        }
    }
};
export default actions;
